// i18n - lightweight localization.
//
// Language picked in the menu (storage), else the browser's; English fallback.
// Usage:  import { t } from './i18n.js';
//         t('hud.wave', { wave: 5 })  →  "Wave: 5"

import en from './lang/en.js';
import ru from './lang/ru.js';
import { getSavedLang, setSavedLang } from './storage.js';

const LANGS = { en, ru };

function detectLang() {
  const saved = getSavedLang();
  if (saved && LANGS[saved]) return saved;
  const nav = (typeof navigator !== 'undefined') ? navigator.language || '' : '';
  if (nav.startsWith('ru')) return 'ru';
  return 'en';
}

let current = LANGS[detectLang()] || en;

export function setLang(code) {
  current = LANGS[code] || en;
}

/** Switch language from the menu and remember the choice. */
export function toggleLang() {
  const next = getLang() === 'ru' ? 'en' : 'ru';
  setLang(next);
  setSavedLang(next);
}

export function getLang() {
  return current === ru ? 'ru' : 'en';
}

/** Translate key, interpolating `{name}` placeholders from `params`. */
export function t(key, params) {
  let s = current[key];
  if (s === undefined) s = en[key];
  if (s === undefined) return key;
  if (params) {
    for (const k in params) {
      s = s.replaceAll(`{${k}}`, params[k]);
    }
  }
  return s;
}
